import { useEffect, useRef, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import viewlist from "../../assets/images/view_list.svg";
import view_module from "../../assets/images/view_module.svg";
import floderaddicon from "../../assets/svg/Assetmanagemant/edit.svg";
import icroundsearch from "../../assets/svg/Assetmanagemant/search.svg";
import NextButton from "../../component/Common/NextButton";
import PrevButton from "../../component/Common/PrevButton";
import "./cmsdashboard.scss";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Partner_archive,
  Partner_delete,
  Partner_list,
  Partner_search,
  ProgramsList_By_Partner
} from "../../api/api";
import assetpart from "../../assets//svg/Assetmanagemant/media.svg";
import viewIcon from "../../assets/images/carbon_view.svg";
import desc from "../../assets/images/desc.png";
import filter_alt from "../../assets/images/sortarrow.png";
import archiveicon from "../../assets/svg/Assetmanagemant/archiveIcon.svg";
import deleteicon from "../../assets/svg/Assetmanagemant/deleteIcon.svg";
import editicon from "../../assets/svg/Assetmanagemant/editIcon.svg";
import menuIcon from "../../assets/svg/Assetmanagemant/menu.svg";
import Loader from "../../component/Loader/Loader";
import AddPartnerpopup from "../../component/popup/AddPartnerpopup";
import { DateStamp, isLogin } from "../../service/commonFunc";
import { permissionDetails } from "../../utility/localStoageData";
import Filler from "./channeldetail/Filler";

function AssetManagement() {
  const navigate = useNavigate();
  // List view
  
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isContentLoading, setIsContentLoading] = useState(false);

  const [activeView, setActiveView] = useState("grid");
  const [PartnerData, setPartnerData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [createEdit, setCreateEdit] = useState("create");
  const [singledata, setSingleData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [fillerSearchQuery, setFillerSearchQuery] = useState("");
  const [permission, setpermission] = useState(null);
  const [currentData, setCurrentData] = useState([]);
  const {
    appThemeReducer: { appTheme },
    adminModeReducer: { adminMode },
  } = useSelector((state) => state);
  const handleViewChange = (view) => {
    setActiveView(view);
  };

  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("ASSET_MANAGEMENT_EDIT")) setpermission("edit");
    else if (findEdit.includes("ASSET_MANAGEMENT_READ")) setpermission("read");
    else setpermission(null);
  };

  useEffect(() => {
    isLogin();
    // partnerListDetail();  // commented beacuse of unnecessary api call. 
    getPermission();
  }, []);
  const partnerListDetail = async () => {
    setIsContentLoading(true); // Start loader
    const partnerData = await Partner_list();

    if (partnerData?.data && partnerData?.status === true) {
      setPartnerData(partnerData?.data.content);
       setIsContentLoading(false); // Stop loader after all content is set
    }
  };

  const partnerSearch = async (searchQuery) => {
    const partnerDataSearch = await Partner_search(searchQuery);

    if (partnerDataSearch?.data && partnerDataSearch?.status === true) {
      setPartnerData(partnerDataSearch?.data);
      setCurrentData(PartnerData.slice(startIndex, endIndex));
      setCurrentPage(1);
    }
  };
  
  useEffect(() => {
    setStartIndex((currentPage - 1) * itemsPerPage);
    setEndIndex( startIndex + itemsPerPage);
    setTotalPages(Math.ceil(PartnerData.length / itemsPerPage));
    setCurrentData(PartnerData.slice(startIndex, endIndex));
  },[PartnerData, currentPage, startIndex, endIndex]);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };


  // Create an array to store open states for each card
  
 const [isDropdownOpenArray, setIsDropdownOpenArray] = useState(
   false
  );

  // For Adding Dropdown
  const [openDropdown, setOpenDropdown] = useState(null); // Store open dropdown ID

  const NewDropdown = ({ index, folder ,isOpen, setOpenDropdown}) => {
   const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setOpenDropdown]);

 // ✅ Close on mouse leave
  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

    return(
      <div ref={dropdownRef} >
        <Dropdown
          show={isOpen} onToggle={() => setOpenDropdown(isOpen ? null : index)}
        >
          <Dropdown.Toggle
            id={`dropdown-basic-${folder.id}`}
            variant="light"
            style={{ cursor: "pointer", zIndex: 9999 }} // Ensure button has high z-index
            className="three-dots"

          >
           
            <img src={menuIcon} alt="Menu" className="Menuicon" style={{
              filter: "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
            }} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="custom-dropdown-menu"
            // style={{ marginLeft: -40 }}
            onMouseLeave={handleMouseLeave}
          >
            <Dropdown.Item
              onClick={(e) => {
                e.stopPropagation();
                openEditPartnerPopup(folder);
                setOpenDropdown(isOpen ? null : index)
              }}
              eventKey="option1"
              onSelect={(e) =>
                handleDropdownSelect("option1", index)
              }
            >
             <div className="dropDownMenuIcon"><img src={editicon} alt="" /></div>  Edit
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="option2"
              onSelect={() =>
                handleDropdownSelect("option2", index)
              }
              onClick={(e) => {
                e.stopPropagation();
                partnerArchive(folder.id);
                setOpenDropdown(isOpen ? null : index)
              }}
            >
              <div className="dropDownMenuIcon"><img src={archiveicon} alt="" /></div> Archive
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="option3"
              onSelect={() =>
                handleDropdownSelect("option3", index)
              }
              onClick={(e) => {
                e.stopPropagation();
                partnerDelete(folder.id);
                setOpenDropdown(isOpen ? null : index)
              }}
            >
              <div className="dropDownMenuIcon"><img src={deleteicon} alt="" /></div> Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }



   // For Edit Dropdown
  const [openDropdownEdit, setOpenDropdownEdit] = useState(null); // Store open dropdown ID

  const NewDropdownEdit = ({ index, row ,isOpen, setOpenDropdownEdit}) => {
   const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownEdit(null);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setOpenDropdownEdit]);

 // ✅ Close on mouse leave
  const handleMouseLeave = () => {
    setOpenDropdownEdit(null);
  };
    return (
      <div ref={dropdownRef}>
        <Dropdown
          show={isOpen}
          onToggle={() => setOpenDropdownEdit(isOpen ? null : index)}
        >
          <Dropdown.Toggle
            id={`dropdown-basic-${row.id}`}
            variant="light"
            style={{ cursor: "pointer" }}
          >
            {/* <span className="three-dots">⋮</span> */}
            <img
              src={menuIcon}
              alt="Menu"
              className="Menuicon"
              style={{
                filter:
                  "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
              }}
            />
          </Dropdown.Toggle>
          <Dropdown.Menu 
          onMouseLeave={handleMouseLeave}
          className="custom-dropdown-menu"
          >
            <Dropdown.Item
              eventKey="option1"
              onSelect={() => handleDropdownSelect("option1", index)}
              onClick={(e) => {
                e.stopPropagation();
                openEditPartnerPopup(row);
                setOpenDropdownEdit(isOpen ? null : index);
              }}
            >
              <div className="dropDownMenuIcon"><img src={editicon} alt="" /></div> Edit
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="option2"
              onSelect={() => handleDropdownSelect("option2", index)}
              onClick={(e) => {
                e.stopPropagation();
                partnerArchive(row.id);
                setOpenDropdownEdit(isOpen ? null : index);
              }}
            >
              <div className="dropDownMenuIcon"><img src={archiveicon} alt="" /></div> Archive
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="option3"
              onSelect={() => handleDropdownSelect("option3", index)}
              onClick={(e) => {
                e.stopPropagation();
                partnerDelete(row.id);
                setOpenDropdownEdit(isOpen ? null : index);
              }}
            >
              <div className="dropDownMenuIcon"><img src={deleteicon} alt="" /> </div> Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  
  const handleDropdownSelect = (selectedOption, index) => {
    // Implement the action for the selected option here
    // Close the dropdown for the selected card
    setIsDropdownOpenArray((prevState) =>
      prevState.map((value, i) => (i === index ? false : value))
    );
  };

  //add partner pop

  const openCreatePartnerPopup = () => {
    setCreateEdit("create");
    setShowPopup(true);
  };

  const openEditPartnerPopup = (partner) => {
    setCreateEdit("edit");
    setSingleData(partner);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setCreateEdit("create"); // Reset to create mode
    setSingleData(null); // Clear the single data
    partnerListDetail();
  };

  // search
  const handleSearch = (e) => {
    // Call your search API with the searchQuery value
    // You can use libraries like Axios or fetch for making the API request
    // For this example, we'll use a simple console.log to demonstrate
   if(e.length >= 3 || e.length < 1){
    partnerSearch(e);
   }
   if(activeTab === 2 ){
    setFillerSearchQuery(e);
   }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      partnerSearch(searchQuery);
    }
  };

  const partnerDelete = async (data) => {
    const partnerDelete = await Partner_delete(data);

    if (partnerDelete?.data?.status == true) {
      partnerListDetail();
      toast.success("Content Partner deleted successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error(
        partnerDelete?.message ||
          "Something went wrong, please try after sometime",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
        }
      );
    }
  };
  const partnerArchive = async (data) => {
    const Partnerarchive = await Partner_archive(data);
    if (Partnerarchive.data.status == true) {
      toast.success("Content Partner archived successfully", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  };
  // const dispatch = useDispatch();
 const [isLoading, setIsLoading] = useState(false);

  const partnerdetail = async (assetdetails) => {
    // console.log("asdfghjkl",assetdetail);
    setIsLoading(true); // Show loader
    const params = {
      partnerId: assetdetails.id,
      pageSize: "1000",
    };

    const AssetDetail = await ProgramsList_By_Partner(params);

    if (AssetDetail.status == true) {
      // console.log(AssetDetail.status == true);
      localStorage.setItem("AssetDetail", JSON.stringify(AssetDetail?.data));
      localStorage.setItem("AssetPartnerDetail", JSON.stringify(assetdetails));
       setIsLoading(false); // Hide loader before navigation
      
      navigate("/CmsChannelDetail");
    } else {
      toast.error("Something went wrong, please try after sometime", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
    // dispatch(AssetDetailAction(AssetDetail?.data))
  };
  const formatValue = (value)=>{
    if(typeof(value) === "number"){
      return value.toString().padStart(2, '0'); // Convert number to string and pad with leading zero if needed

    }
  }
  const [sortOrders, setSortOrders] = useState({});
  useEffect(() => {
    const initialSortOrders = {
      viewKey: "asc", // Default sort order for 'filename' column
      lastactivity: "asc",
      Programs: "asc",
      posters: "asc",
      promos: "asc", 
      fillers: "asc",
      // Add more columns as needed
    };
    setSortOrders(initialSortOrders);
  }, []);

  const sortOrderEvent = async (field) => {
    let currentSortOrder = "asc"; // Default sort order

    // Check if the field was previously sorted and toggle the sort order
    if (sortOrders[field]) {
      currentSortOrder = sortOrders[field] === "asc" ? "desc" : "asc";
    }
    setSortOrders({ ...sortOrders, [field]: currentSortOrder });
  };

  const getSortIcon = (field) => {
    if (sortOrders[field] == "desc") {
      // console.log("ASss124t");
      return <img src={filter_alt} alt="desc" />; // Image for ascending order
    } else {
      // console.log("ASss",sortOrders[field],field);
      return <img src={desc} alt="Ascending" />; // Image for ascending order
    }
  };

  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

   useEffect(() => {
    setSearchQuery(""); // Clear search query when switching views
    setCurrentPage(1); // Reset to the first page when changing view
    partnerListDetail()
    
    },[activeTab,activeView])

   const [identifier, setIdentifier] = useState("");
    useEffect(()=>{
      const tenantLocalData = localStorage.getItem('tenantInfo');
      const tenantLocalDataParse = JSON.parse(tenantLocalData);
    setIdentifier(tenantLocalDataParse?.code);
    },[])
console.log("identifier",identifier);

  return permission !== null ? (
    <div
      className={`content-body ${
        adminMode || appTheme === "dark" ? "dark" : "light"
      }`}
    >
       {/* Loader overlay */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(41, 40, 40, 0.7)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Loader />
        </div>
      )}
      <div
        className={`dashboard-content ${
          adminMode || appTheme === "dark" ? "dark" : "light"
        }`}
      >
        <div className="top-content" style={{marginBottom:"10px"}}>
          <div className="left-side">
            <h3>Asset Management</h3>
          </div>
          <div className="right-side">
            <div className="icon-list">
              <div className="search-container" style={{ width: "324px", }}>
                <input
                  id="search-input"
                  className="search-box"
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    handleSearch(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                  style={{
                    width: "100%",
                    border: "none",
                    height: "40px",
                    color: appTheme === "dark" ? "#ffffff" : "black",
                    borderRadius: "6px",
                    padding: "0 10px",
                  }}
                />
                <button
                  className="search-button"
                  onClick={handleSearch}
                  aria-label="Search"
                  style={{
                    cursor: "pointer",
                    padding: "0",
                    backgroundColor: "transparent",
                    color: appTheme === "dark" ? "#ffffff" : "black",
                  }}
                >
                  <img
                    src={icroundsearch}
                    alt="Search"
                    className="search-icon"
                    style={{
                  //     filter:
                  //  appTheme === "dark"
                  //         ? "invert(100%) brightness(150%)"
                  //         : "none",
                          color:'#D22F26',
                    }}
                  />
                </button>
              </div>

              {permission === "edit" && (
                <div className="add-icon">
                  <a className="icon" onClick={openCreatePartnerPopup} style={{backgroundColor:'#444649 ', border:'#444649'}}>
                    <img src={floderaddicon} alt="" />
                  </a>
                </div>
              )}

              <div className="view-list">
                <a
                  className={`grid-icon icon ${
                    activeView === "grid" ? "active" : ""
                  }`}
                  onClick={() => handleViewChange("grid")}
                >
                  <img src={view_module} alt="" />
                </a>
                <a
                  className={`grid-icon icon ${
                    activeView === "list" ? "active" : ""
                  }`}
                  onClick={() => handleViewChange("list")}
                >
                  <img src={viewlist} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className={`row ${activeView === "grid" && PartnerData.length !== 0 ? 'newgrid' : ""}`} >
          {activeView === "grid" ? (
            <>
           {isContentLoading ? (
                <div style={{
                    height:"80vh",
                    width:"80vw",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                    borderRadius:"8px"
                  }}>
                  <Loader />
                </div>
                ):(PartnerData.length !== 0 ? (
            PartnerData.filter(folder => !(identifier === "nhstdz" && folder.name === "All Partners")) 
            .map((folder, index) => (
              <div
                key={folder.id}
                 className="partner-card-column"
                
              >
                <Card 
                  onClick={(e) => {
                   if (e.nativeEvent.target.className === "Menuicon") {
                      return;
                    }
                    partnerdetail(folder);
                  }}
                  style={{
                    cursor: "pointer",
                    }}
                  className={`${appTheme}`}
                >
                  <Card.Header className={`${appTheme}`}>
                    <div className="d-flex justify-content-between partner-card">
                      <div>
                        <img className={`${appTheme}`} src={assetpart} alt = 'media' style={{
                              filter : "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                            }}  />
                        <b className="mx-2">{folder.name}</b>
                      </div>
                      {permission === "edit" ? (
                      
                       <NewDropdown index={index} folder={folder} isOpen={openDropdown === index}
                          setOpenDropdown={setOpenDropdown}/>

                      ) : permission === "read" ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            openEditPartnerPopup(folder);
                          }}
                          eventKey="option1"
                          onSelect={(e) =>
                            handleDropdownSelect("option1", index)
                          }
                        >
                          <img src={viewIcon} alt="" width="18px" />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div>
                     
                      <b className="programsCount"> Programs : <span>{formatValue(folder.programsCount)}</span></b>
                      <div className="p-0 m-0 mt-2 row">
  <div className="col-4 px-0">
    <div
      className="chip-prog chip-transcode "
      style={{
        backgroundColor: appTheme === "dark" ? "#7B07D7" : "#C8EBFF",
        color: appTheme === "dark" ? "#fff" : "#000",
        wordWrap: "break-word",
        whiteSpace: "normal", 
        maxWidth: '100%', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
      }}
    >
      <span>Transcoded</span>
      <span className="text-center">
        <b
          style={{
            color: appTheme === "dark" ? "#fff" : "#000",
            marginLeft: 5,
          }}
        >
          {formatValue(folder.transcodeCount)}{" "}
        </b>
      </span>
    </div>
  </div>
  <div className="col-4 px-0">
    <div
      className="chip-prog chip-validation "
      style={{
        backgroundColor: appTheme === "dark" ? "#0749D7" : "#DDDCFF",
        color: appTheme === "dark" ? "#fff" : "#000",
        wordWrap: "break-word", 
        whiteSpace: "normal",
        padding: '5px', 
        maxWidth: '100%', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
      }}
    >
      <span>Validated</span>
      <span className="text-center">
        <b
          style={{
            color: appTheme === "dark" ? "#fff" : "#000",
            marginLeft: 5,
          }}
        >
          {formatValue(folder.validateCount)}
        </b>
      </span>
    </div>
  </div>
  <div className="col-4 px-0">
    <div
      className="chip-prog chip-publish"
      style={{
        backgroundColor: appTheme === "dark" ? "#01766A" : "#FED9D7",
        color: appTheme === "dark" ? "#fff" : "#000",
        wordWrap: "break-word", 
        whiteSpace: "normal", 
        padding: '5px', 
        maxWidth: '100%', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
      }}
    >
      <span>Published</span>
      <span className="text-center">
        <b
          style={{
            color: appTheme === "dark" ? "#fff" : "#000",
            marginLeft: 5,
          }}
        >
          {formatValue(folder.publishCount)}
        </b>
      </span>
    </div>
  </div>
</div>



                    </div>
                  </Card.Body>
                
           
                 
<div
  className="chips-container"
>
  <span
    className="chip-second"
    style={{
      backgroundColor: appTheme === "dark" ? "#000" : "#fff",
      color: appTheme === "dark" ? "#fff" : "#000",
      
    }}
  >
    Posters :
    <span>
      <b>{folder.postersCount ? formatValue(folder.postersCount) : '00'}</b>
    </span>
  </span>
  <span
    className="chip-second"
    style={{
      backgroundColor: appTheme === "dark" ? "#000" : "#fff",
      color: appTheme === "dark" ? "#fff" : "#000"
    }}
  >
    Promos :
    <span>
       <b>{formatValue(folder.promosCount)}</b>
    </span>
  </span>
  <span
    className="chip-second"
    style={{
      backgroundColor: appTheme === "dark" ? "#000" : "#fff",
      color: appTheme === "dark" ? "#fff" : "#000",
      
    }}
  >
    Fillers :
    <span>
      <b>{formatValue(folder.fillersCount)}</b>
    </span>
  </span>
</div>


                </Card>
              </div>
            ))):(<>
                <div className="fallbackPage">No Data Found.</div>
            </>)
          )}
          </>
          ) : (
            <div className="w-100">
              <div className="tab-buttons">
                <a
                  onClick={() => handleTabClick(1)}
                  className={`tab ${activeTab === 1 ? "active" : ""}`}
                >
                  Partners
                </a>
                <a
                  onClick={() => handleTabClick(2)}
                  className={`tab ${activeTab === 2 ? "active" : ""}`}
                >
                  Fillers
                </a>
              </div>

              <div className="my-4">
                {activeTab === 1 && (
                  <div className="table table-checkbox">
               

                    <table className="listTable text-center"
                     style={{
    borderCollapse: "separate",
    borderSpacing: "0 6px", 
  }}>
      <thead>
        <tr 
        >
          <th
            className="mx-2"
            style={{
              width: "20%",
              textAlign: "left",
              padding: "10px",
              paddingLeft: "50px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            PARTNER NAME
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("viewKey")}
            >
              {getSortIcon("viewKey")}
            </a>
          </th>
          <th
            style={{
              width: "15%",
              textAlign: "center",
              padding: "10px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            LAST ACTIVITY
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("lastactivity")}
            >
              {getSortIcon("lastactivity")}
            </a>
          </th>
          <th
            style={{
              width: "30%",
              textAlign: "center",
              padding: "10px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            PROGRAMS{" "}
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("Programs")}
            >
              {getSortIcon("Programs")}
            </a>
          </th>
          <th
            style={{
              width: "20%",
              padding: "10px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            POSTERS{" "}
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("posters")}
            >
              {getSortIcon("posters")}
            </a>
          </th>
          <th
            style={{
            
              padding: "10px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            PROMOS{" "}
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("promos")}
            >
              {getSortIcon("promos")}
            </a>
          </th>
          <th
            style={{
              width: "15%",
              padding: "10px",
              color: appTheme === "dark" ? "#ffffff" : "black",
            }}
          >
            FILLERS
            <a
              className="filter-icon mx-1"
              onClick={() => sortOrderEvent("fillers")}
            >
              {getSortIcon("fillers")}
            </a>
          </th>
          {permission === "edit" ? (
            <th style={{ padding: "10px" }}></th>
          ) : permission === "read" ? (
            <th style={{ padding: "10px" }}>View</th>
          ) : (
            ""
          )}
        </tr>
      </thead>
      {currentData.length !== 0 ? (
        <tbody
        >
          {currentData.map((row, index) => (
            <tr
              className={index % 2 === 0 ? "even" : "odd"}
              key={row.id}
              onClick={() => {
                partnerdetail(row);
              }}
              style={{
            cursor: "pointer",
            backgroundColor: appTheme === "dark"
              ? (index % 2 === 0 ? "#121212" : "#1a1a1a")
              : (index % 2 === 0 ? "#121212" : "#121212"),
            transition: "background-color 0.2s ease, transform 0.2s ease",
            border: `1px solid ${appTheme === "dark" ? "#000" : "#000"}`, 
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor =
              appTheme === "dark" ? "#2a2a2a" : "#121212"; 
            e.currentTarget.style.transform = "scale(1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor =
              appTheme === "dark"
                ? (index % 2 === 0 ? "#121212" : "#1a1a1a")
                : (index % 2 === 0 ? "#121212" : "#121212");
            e.currentTarget.style.transform = "scale(1)";
          }}
            >
              <td style={{ textAlign: "left", padding: "10px",   backgroundColor: "#121212",  }}>
                <img
                  className={`${appTheme}`}
                  style={{
                    height: "25px",
                    marginRight: "10px",
                    filter:
                      appTheme === "dark"
                        ? "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)"
                        : "none",
                  }}
                  src={assetpart}
                  alt = 'media'
                />
                <span> {row?.name}</span>
              </td>
              <td style={{ padding: "10px",   backgroundColor: "#121212",  }}>{DateStamp(row.updatedAt)}</td>
              <td className="p-1 " style={{ padding: "10px" ,   backgroundColor: "#121212", }}>
                <div style={{ fontWeight: 600 }}>
                  {row.programsCount}
                </div>
                <div
                  className="all-text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "space-between",
                    
                  }}
                >
                  <span
                    className="chip-transcode"
                    style={{
                      backgroundColor:
                        appTheme === "dark" ? "#7B07D7" : "#C8EBFF",
                      color: appTheme === "dark" ? "#fff" : "#000",
                      flex: 1,
                      marginRight: 5,
                      textAlign: "center",
                      whiteSpace: "nowrap", 
                      // overflow: "hidden", 
                    
                      
                    }}
                  >
                    Transcoded: {row.transcodeCount}
                  </span>
                  <span
                    className="chip-validation"
                    style={{
                      backgroundColor:
                        appTheme === "dark" ? "#0749D7" : "#DDDCFF",
                      color: appTheme === "dark" ? "#fff" : "#000",
                      flex: 1,
                      marginRight: 5,
                      textAlign: "center",
                      whiteSpace: "nowrap", 
                    }}
                  >
                    Validated: {row.validateCount}
                  </span>
                  <span
                    className="chip-publish"
                    style={{
                      backgroundColor:
                        appTheme === "dark" ? "#01766A" : "#FED9D7",
                      color: appTheme === "dark" ? "#fff" : "#000",
                      flex: 1,
                      textAlign: "center",
                      whiteSpace: "nowrap", 
                    }}
                  >
                    Published: {row.publishCount}
                  </span>
                </div>
              </td>
              <td style={{ padding: "10px" ,   backgroundColor: "#121212", }}>
                {row?.postersCount ? row?.postersCount : 0}
              </td>
              <td style={{ padding: "10px",   backgroundColor: "#121212",  }}>{row.promosCount}</td>
              <td style={{ padding: "10px" ,   backgroundColor: "#121212", }}>{row.fillersCount}</td>
              {permission === "edit" ? (
                <td
                  style={{ padding: "10px" ,   backgroundColor: "#121212", }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <NewDropdownEdit index={index} row={row} isOpen={openDropdownEdit === index}  setOpenDropdownEdit={setOpenDropdownEdit}/>
                </td>
              ) : permission === "read" ? (
                <td style={{ padding: "10px" }}>
                  <a>
                    <div
                      eventKey="option1"
                      onSelect={() =>
                        handleDropdownSelect("option1", index)
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        openEditPartnerPopup(row);
                      }}
                    >
                      <img src={viewIcon} alt="" width="18px" />
                    </div>
                  </a>
                </td>
              ) : (
                ""
              )}
            </tr>
          ))}
        </tbody>
      ) : (
        <tbody>
          <tr>
            <td colSpan="7" style={{ textAlign: "center", padding: "10px" }}>
              Match not found
            </td>
          </tr>
        </tbody>
      )}
    </table>


    <div className="table-pagination">
  <div className="pagination-count">
    <div className="count">
       Showing <span>
      {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
        currentPage * itemsPerPage,
        PartnerData.length
      )} of ${PartnerData.length}`}  </span> entries
    </div>
    <div className="pagination-arrow">
      <button
        className={`prev ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() =>
          currentPage > 1 && handlePageChange(currentPage - 1)
        }
      >
        <PrevButton/>
      </button>
      {/* <div className="page-number-box">{currentPage}</div> */}
       <div className="pagesCounts">
                    Page
      <input
                    className="page-number-box"
                    type="number"
                    value={currentPage}
                    min="1"
                    max={PartnerData.length}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only update if it's a valid number
                      if (/^\d*$/.test(value)) {
                        setCurrentPage(value ? Number(value) : "");
                      }
                    }}
                    onBlur={(e) => {
                      let value = Number(e.target.value);
                      if (!value || value < 1) value = 1;
                      if (value > PartnerData.length)
                        value = PartnerData.length;
                      setCurrentPage(value);
                    }}
                  />
                   <span>of {totalPages}</span>
                  </div>
      
      <button
        className={`next ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={() =>
          currentPage < totalPages && handlePageChange(currentPage + 1)
        }
      >
        <NextButton/>
      </button>
    </div>
  </div>
</div>

                  </div>
                )}
                {activeTab === 2 && <Filler permission={permission}  searchParam = {fillerSearchQuery}/>}
              </div>
            </div>
          )}

          <ToastContainer />

          <AddPartnerpopup
            show={showPopup}
            handleClose={closePopup}
            isEditing={createEdit === "edit"}
            partnerData={singledata}
            permission={permission}
          />
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}

export default AssetManagement;
